import CommandLayout from "@/components/CommandLayout";
import SEO from "@/components/SEO";
import { Scale, FileText, ExternalLink, Info, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Legal = () => {
  return (
    <CommandLayout>
      <SEO
        title="Legal Information — GreyRock AI®"
        description="Privacy policy, terms of service, refund policy and contact details for GreyRock AI® — the forensic communication analysis tool."
        path="/legal"
      />
      <div className="max-w-2xl mx-auto space-y-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">
            <span className="text-foreground">Legal </span>
            <span className="text-gradient-cyan">Information</span>
          </h1>
          <p className="text-muted-foreground">
            GreyRock AI&reg; policies and terms of use
          </p>
        </div>

        {/* Privacy Policy */}
        <section className="glass-card p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-cyan/10">
              <Scale className="w-6 h-6 text-cyan" />
            </div>
            <h2 className="font-semibold text-lg">Privacy Policy</h2>
          </div>
          <p className="text-muted-foreground leading-relaxed">
            We process messages in real-time and do not store sensitive content.
          </p>
          <Link to="/privacy" className="inline-flex items-center gap-1.5 text-sm text-cyan hover:underline">
            Full Privacy Policy <ExternalLink className="w-3.5 h-3.5" />
          </Link>
        </section>

        {/* Terms of Service */}
        <section className="glass-card p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-cyan/10">
              <FileText className="w-6 h-6 text-cyan" />
            </div>
            <h2 className="font-semibold text-lg">Terms of Service</h2>
          </div>
          <p className="text-muted-foreground leading-relaxed">
            Credits are non-refundable and usage is subject to fair use limits.
          </p>
          <Link to="/terms" className="inline-flex items-center gap-1.5 text-sm text-cyan hover:underline">
            Full Terms of Service <ExternalLink className="w-3.5 h-3.5" />
          </Link>
        </section>

        {/* Trademark */}
        <section className="glass-card p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-cyan/10">
              <Scale className="w-6 h-6 text-cyan" />
            </div>
            <h2 className="font-semibold text-lg">Trademark</h2>
          </div>
          <p className="text-muted-foreground leading-relaxed">
            GreyRock AI&reg; is a registered trademark of Should I Studios LLC, U.S. Reg. No. 8435211, registered September 15, 2026.
          </p>
        </section>

        {/* About */}
        <section className="glass-card p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-cyan/10">
              <Info className="w-6 h-6 text-cyan" />
            </div>
            <h2 className="font-semibold text-lg">About GreyRock AI&reg;</h2>
          </div>
          <p className="text-muted-foreground leading-relaxed">
            Learn about our mission, values, and the team behind the platform.
          </p>
          <Link to="/about" className="inline-flex items-center gap-1.5 text-sm text-cyan hover:underline">
            About Us <ExternalLink className="w-3.5 h-3.5" />
          </Link>
        </section>

        {/* Contact */}
        <section className="glass-card p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-cyan/10">
              <Mail className="w-6 h-6 text-cyan" />
            </div>
            <h2 className="font-semibold text-lg">Contact Us</h2>
          </div>
          <p className="text-muted-foreground leading-relaxed">
            Have a question? Reach out for support, partnerships, or media inquiries.
          </p>
          <Link to="/contact" className="inline-flex items-center gap-1.5 text-sm text-cyan hover:underline">
            Contact Form <ExternalLink className="w-3.5 h-3.5" />
          </Link>
        </section>
      </div>
    </CommandLayout>
  );
};

export default Legal;
